import React from 'react';
import { useRipple } from '../hooks/useRipple';

export const RippleButton = ({ children, className, onClick, ...props }) => {
  const { ripples, addRipple } = useRipple();

  const handleClick = (event) => {
    addRipple(event);
    if (onClick) {
      onClick(event);
    }
  };

  return (
    <button
      className={`relative overflow-hidden ${className}`}
      onClick={handleClick}
      {...props}
    >
      {children}
      {ripples.map((ripple) => (
        <span
          key={ripple.id}
          className="ripple-effect"
          style={{
            left: ripple.x,
            top: ripple.y,
            width: ripple.size,
            height: ripple.size,
          }}
        />
      ))}
    </button>
  );
};

export const RippleLink = ({ children, className, onClick, href, target, rel, ...props }) => {
  const { ripples, addRipple } = useRipple();

  const handleClick = (event) => {
    addRipple(event);
    if (onClick) {
      onClick(event);
    }
  };

  return (
    <a
      href={href}
      target={target}
      rel={rel}
      className={`relative overflow-hidden inline-block ${className}`}
      onClick={handleClick}
      {...props}
    >
      {children}
      {ripples.map((ripple) => (
        <span
          key={ripple.id}
          className="ripple-effect"
          style={{
            left: ripple.x,
            top: ripple.y,
            width: ripple.size,
            height: ripple.size,
          }}
        />
      ))}
    </a>
  );
};
